export const TopicsData = [
  {
    "eng": "Spelling. Reading Rules",
    "ukr": "Вимова. Правила читання"
  },
  {
    "eng": "Pronouns. To Be",
    "ukr": "Займенники. Дієслово To Be"
  },
  {
    "eng": "All Tenses Overview. Present Simple",
    "ukr": "Огляд всіх часів. Теперішній простий час"
  },
  {
    "eng": "Future Simple",
    "ukr": "Майбутній простий час"
  },
  {
    "eng": "Past Simple",
    "ukr": "Минулий простий час"
  },
  {
    "eng": "Irregular Verbs",
    "ukr": "Неправильні дієслова"
  },
  {
    "eng": "Simple Tenses: Summary",
    "ukr": "Прості часи: підсумок"
  },

  {
    "eng": "Present Continuous Tense",
    "ukr": "Теперішній тривалий час"
  },
  {
    "eng": "Future Continuous Tense",
    "ukr": "Майбутній тривалий час"
  },
  {
    "eng": "Past Continuous Tense",
    "ukr": "Минулий тривалий час"
  },
  {
    "eng": "Continuous Tenses: Summary",
    "ukr": "Тривалі часи: підсумок"
  },
  {
    "eng": "Present Perfect Tense",
    "ukr": "Теперішній доконаний час"
  },
  {
    "eng": "Present Perfect Continuous Tense",
    "ukr": "Теперішній доконаний тривалий час"
  },
  {
    "eng": "All Tenses Comparison",
    "ukr": "Порівняння всіх часів"
  },
  {
    "eng": "Prepositions of Place",
    "ukr": "Прийменники місця"
  },
  {
    "eng": "Time and Date",
    "ukr": "Час і дата"
  },
  {
    "eng": "Articles. There is/there are",
    "ukr": "Артиклі. Конструкція There is/There are"
  },
  {
    "eng": "Singular and Plural. Comparative and Superlative. Ordinal and Cardinal",
    "ukr": "Однина і множина. Ступені порівняння. Порядкові й кількісні числівники"
  },
  {
    "eng": "Active Voice and Passive Voice",
    "ukr": "Активний і пасивний стан"
  },
  {
    "eng": "Modal Verbs, Would and Used to",
    "ukr": "Модальні дієслова, конструкції Would і Used to"
  },
  {
    "eng": "Imperative Sentences",
    "ukr": "Наказові речення"
  },
  {
    "eng": "Relative Clauses", //22
    "ukr": "Підрядні речення"
  },
  {
    "eng": "Reported Speech", //23
    "ukr": "Непряма мова"
  },
  {
    "eng": "Simple Tense Recap. Irregular Verbs Part II", //24
    "ukr": "Прості часи: повторення. Неправильні дієслова - частина 2"
  },
  {
    "eng": "Continues Tense Recap", //25
    "ukr": "Тривалі часи: повторення"
  },
  {
    "eng": "Present Perfect and Present Perfect Continuous Recap", //26
    "ukr": "Теперішній доконаний і Теперішній доконаний тривалий: повторення"
  },
  {
    "eng": "All Tenses Recap", //27
    "ukr": "Повторення всіх часів"
  },
  {
    "eng": "Rarely Used Tenses", //28
    "ukr": "Рідковживані часи"
  },
  {
    "eng": "8 basic rules of Grammar (part 1)",  //29
    "ukr": "8 основних правил граматики (частина 1)"
  },
  {
    "eng": "8 basic rules of Grammar (part 2)", //30
    "ukr": "8 основних правил граматики (частина 2)"
  },
]